@if(menuItems && !disabled) {
<div class="dropdown-container">
  <button
    #triggerBtn
    [type]="type"
    [disabled]="disabled"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeydown($event)"
    [attr.aria-label]="'Menu Clickable'"
    [attr.aria-expanded]="showDropdown"
    [ngClass]="customClass">
    <ng-container *ngIf="icon && iconPosition === 'left'">
      <i class="fa fa-chevron-down"></i>
    </ng-container>
    {{ label }}
    <ng-container *ngIf="icon && iconPosition === 'right'">
      <i class="fa fa-chevron-down"></i>
    </ng-container>
  </button>

  <div
    class="dropdown-list"
    *ngIf="showDropdown"
    role="menu"
    #menuPanel>
    <div class="dropdown-item">
      <div *ngFor="let category of objectKeys(menuItems)">
        <div class="category-title" role="presentation">{{ category }}</div>
        <div *ngFor="let menuItem of menuItems[category]; let innerIndex = index">
          <div *ngIf="menuItem.display === 'y'" class="mt-1">
            <ppl-menu-button
              #mi
              role="menuitem"
              [attr.tabindex]="getFlatIndex(category, innerIndex) === activeIndex ? 0 : -1"
              [label]="menuItem.menu_label ?? ''"
              [customClass]="'fancy-button'"
              [iconPosition]="'right'"
              [item]="menuItem"
              (click)="OnMenuClick(menuItem)"
              (keydown)="onItemKeydown($event, menuItem, getFlatIndex(category, innerIndex))"
              (keydown.enter)="OnMenuClick(menuItem); $event.preventDefault(); $event.stopPropagation()"
              (keydown.space)="OnMenuClick(menuItem); $event.preventDefault(); $event.stopPropagation()">
            </ppl-menu-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
